import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  vehiclesList: []
};
const vehiclesReducer = createSlice({
  name: 'vehicles',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getVehiclesList(state, action) {
      return {
        ...state,
        vehiclesList: action.payload?.data?.data,
        count: action.payload?.data?.count
      };
    },
    getVehicleById(state, action) {
      return {
        ...state,
        vehicleInfo: action.payload?.data
      };
    },
    isActive(state, action) {
      const newList = [...state.vehiclesList].map((item) => {
        if (item.id === action.payload) {
          return { ...item, inactive: !item.inactive };
        } else return item;
      });
      return {
        ...state,
        vehiclesList: newList
      };
    }
  }
});

export default vehiclesReducer.reducer;

export const vehiclesActions = vehiclesReducer.actions;

export const editVehicleInactive = (id) => async (dispatch) => {
  try {
    const res = await api.patch(`api/Vehicle/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(vehiclesActions.isActive(id));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const createVehicle = (role) => async () => {
  try {
    const res = await api.post(`api/Vehicle`, role);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const editVehicle = (data, id) => async () => {
  try {
    const res = await api.put(`api/Vehicle/${id}`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const getVehiclesAction = (data) => async (dispatch) => {
  dispatch(vehiclesActions.setLoading(true));
  try {
    const res = await api.get(`api/Vehicle`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(vehiclesActions.getVehiclesList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(vehiclesActions.setLoading(false));
  }
};
export const getVehicleById = (id) => async (dispatch) => {
  dispatch(vehiclesActions.setLoading(true));
  try {
    const res = await api.get(`api/Vehicle/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(vehiclesActions.getVehicleById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(vehiclesActions.setLoading(false));
  }
};
export const clearVehicleById = () => async (dispatch) => {
  dispatch(vehiclesActions.getVehicleById(''));
};
export const removeVehicleAction =
  (id, setRemoveDialog) => async (dispatch) => {
    try {
      const res = await api.delete(`api/Vehicle/${id}`);
      if (res.status === 200 && res?.data) {
        setRemoveDialog('');
        toast.success('Removed successfully!!!');
        return Promise.resolve(res?.data);
      }
    } catch (errors) {
      formErrorsHandle(errors.response?.data, []);
      return Promise.reject(errors.response?.data);
    }
  };
